export default function useVariable() {


    const variableType = (variable) => {
        return typeof variable
    }

    const variableValue = (variable, defaultValue = null) => {
        
        return variable && variable !== undefined && variable.length !== 0 ? variable : (defaultValue ? defaultValue : null)
    }

    const variableMapping = (variable, callback) => {
        return typeof variable === 'object' ?
            Object.keys(variable).forEach((key) => { callback(key) }) :
            (Array.isArray(variable) ? variable.map((item, key) => { callback(item, key) }) : null)
    }


return{
    variableType,
    variableValue,
    variableMapping
}

}